import React, { useEffect, useState } from "react";

const AboutUsEditor = () => {
  const [formData, setFormData] = useState({
    id: 2,
    about_image: [],
    about_title: "",
    about_text: "",
    about_button_text: "",
    about_button_link: "",
  });

  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchAboutUs();
  }, []);

  const fetchAboutUs = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(
        "https://eventscons.com/eventbackendnew/api/aboutus-details?id=2"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status && result.data) {
        setFormData({
          id: result.data.id || 2,
          about_image: result.data.about_image || [],
          about_title: result.data.about_title || "",
          about_text: result.data.about_text || "",
          about_button_text: result.data.about_button_text || "",
          about_button_link: result.data.about_button_link || "",
        });

        setPreviewImage(
          Array.isArray(result.data.about_image)
            ? result.data.about_image[0] || ""
            : result.data.about_image || ""
        );
      } else {
        throw new Error(result.message || "Failed to fetch about us details");
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);

      setFormData((prev) => ({
        ...prev,
        about_image: [file],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    setError("");

    try {
      const payload = new FormData();

      payload.append("id", formData.id);
      payload.append("about_title", formData.about_title || "");
      payload.append("about_text", formData.about_text || "");
      payload.append("about_button_text", formData.about_button_text || "");
      payload.append("about_button_link", formData.about_button_link || "");

      if (
        formData.about_image &&
        formData.about_image.length > 0 &&
        formData.about_image[0] instanceof File
      ) {
        payload.append("about_image", formData.about_image[0]);
      }

      const response = await fetch(
        "https://eventscons.com/eventbackendnew/api/aboutus-update",
        {
          method: "POST",
          body: payload,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "About Us update failed");
      }

      setMessage(result.message || "About Us updated successfully");
      await fetchAboutUs();
    } catch (err) {
      setError(err.message || "Something went wrong while updating");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <p style={styles.loading}>Loading About Us details...</p>;
  if (error && !formData.about_title) {
    return <p style={styles.error}>{error}</p>;
  }

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>About Us Section</h2>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.imageBox}>
            {/* <label style={styles.label}>About Image</label> */}

            {previewImage ? (
              <img
                src={previewImage}
                alt="About Preview"
                style={styles.image}
              />
            ) : (
              <div style={styles.noImageBox}>No image selected</div>
            )}

            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>About Title</label>
            <input
              type="text"
              name="about_title"
              value={formData.about_title}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter about title"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>About Text</label>
            <textarea
              name="about_text"
              value={formData.about_text}
              onChange={handleChange}
              rows="6"
              style={styles.textarea}
              placeholder="Enter about text"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Button Text</label>
            <input
              type="text"
              name="about_button_text"
              value={formData.about_button_text}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter button text"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Button Link</label>
            <input
              type="text"
              name="about_button_link"
              value={formData.about_button_link}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter button link"
            />
          </div>

          {message && <p style={styles.success}>{message}</p>}
          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button} disabled={submitting}>
            {submitting ? "Saving..." : "Update About Us"}
          </button>
        </form>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "40px 20px",
    border: "1px solid #eee",
    background: "#fff",
    margin: "30px",
    boxShadow: "0px 10px 25px #dcdcdc",
    borderRadius: "15px",
  },
  container: {
    maxWidth: "1000px",
    margin: "0 auto",
  },
  heading: {
    marginBottom: "25px",
    fontSize: "28px",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  imageBox: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  image: {
    width: "100%",
    maxWidth: "520px",
    height: "280px",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  noImageBox: {
    width: "100%",
    maxWidth: "520px",
    height: "220px",
    border: "1px dashed #bbb",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
    background: "#fafafa",
    fontWeight: "500",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: "600",
    color: "#333",
  },
  input: {
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "15px",
    width: "100%",
  },
  textarea: {
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "15px",
    resize: "vertical",
    width: "100%",
  },
  button: {
    padding: "14px 20px",
    background: "#9B1321",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    width: "fit-content",
  },
  success: {
    color: "green",
    fontWeight: "600",
  },
  error: {
    color: "red",
    fontWeight: "600",
  },
  loading: {
    padding: "40px",
    textAlign: "center",
  },
};

export default AboutUsEditor;